import { passwordValidationPattern, passwordValidationPatternError } from '../../utils/form-validations';
export const defaultFields = { name: '' };

export const addPasswordUISchema = [
  { id: 1, label: 'Current Password', name: 'currentPassword', type: 'input', required: true },
  { id: 2, label: 'New Password', name: 'newPassword', type: 'input', required: true },
  { id: 3, label: 'Confirm New Password', name: 'confirmPassword', type: 'input', required: true },
];

export const addPasswordSchema = {
  type: 'object',
  properties: {
    password: {
      type: 'string',
    },
    newPassword: {
      type: 'string',
      pattern: passwordValidationPattern,
      errorMessage: {
        pattern: passwordValidationPatternError,
      },
    },
    confirmPassword: {
      const: {
        $data: '1/newPassword',
      },
      type: 'string',
      errorMessage: 'Password does not match',
    },
  },
  required: ['password', 'newPassword', 'confirmPassword'],
  additionalProperties: true,
};
